<template>
    <div>
        <div class="p-3 my-3 bg-light">
            <strong>追跡情報</strong>
        </div>

        <LogTable
            v-model="value"
            :fields="[
                { key: 'shipping_tracking_code', label: '追跡番号', thStyle: { width: 'auto', }, },
            ]"
            :defaultRow="{
                name: null,
            }"
            class="deal-items mt-3"
            :showBtnRowMove="false"
            :autoAddRow="true"
            ref="logTable"
            >
            <template v-slot:cell(shipping_tracking_code)="data">
                <b-form-input
                    v-model="data.item.shipping_tracking_code"
                    size="sm"
                    style="height:2.45em;"
                    @focus="$event.target.select()"
                    ></b-form-input>
            </template>
        </LogTable>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Array,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            timer: null,
            key: 0,
            address_from_id: null,
            address_to_id: null,
            address_importer_id: null,
            prefixes: [ 'from_', 'to_', 'importer_', ],

            order_query: '',
            order_type: 'word',
            data_orders: [],
            data_orders_selected: {},

            data_shipping: {},
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
        total() {
            return this.getTotal(this.value)
        },
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        onSetIsEditMode (value) {
            if (value.is_edit_mode) {
                if (value.images.length) {
                    setTimeout(() => {
                        this.fixImage(value.images[0])
                    }, 1000)
                }
            }
        },
        onInputAddressId (value, prefix) {
            if (!value) {
                let keys = Object.keys(this.value)
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i].indexOf(prefix) !== 0) {
                        continue
                    }
                    this.$set(this.value, keys[i], null)
                }
                return
            }
            let keys = Object.keys(value)
            for (let i = 0; i < keys.length; i++) {
                this.$set(this.value, prefix + keys[i], value[keys[i]])
            }
        },
        onInputBoxId (value, row) {
            let box = {
                depth: null,
                width: null,
                height: null,
                weight: null,
            }
            if (value) {
                box = {
                    depth: value.depth,
                    width: value.width,
                    height: value.height,
                    weight: value.weight,
                }
            }
            this.$utils.set(row, box)
        },
        onInputItemId (value, row) {
            let item = {
                quantity: null,
                hs_code: null,
                country: null,
                product: null,
                price: null,
            }
            if (value) {
                item = {
                    quantity: value.quantity,
                    hs_code: value.hs_code,
                    country: value.country,
                    product: value.product,
                    price: value.price,
                }
            }
            this.$utils.set(row, item)
        },
        getDimensionaWeight(item) {
            let dimensional_weight = parseFloat(item.depth) * parseFloat(item.width) * parseFloat(item.height) / 5000.0
            return Math.ceil(2 * dimensional_weight) / 2 || null
        },
        getSubtotal(item) {
            let subtotal = parseInt(item.quantity || 1) * parseInt(item.price)
            return subtotal || null
        },
        getTotal(value) {
            let data = {
                total_weight: 0,
                total_dimensional_weight: 0,
            }
            for (let i = 0; i < value.length; i++) {
                let dimensional_weight = this.getDimensionaWeight(value[i])
                data.total_weight += (Number.parseFloat(value[i].weight) || 0)
                data.total_dimensional_weight += dimensional_weight || 0
            }
            return data
        },
        onInputHasImporter (is_checked) {
            let elements = Array.from(document.querySelectorAll('.address-content [data*="importer_"]'))
            elements.forEach((element) => {
                element.readOnly = is_checked

                if (is_checked) {
                    this.$set(this.value, element.getAttribute('data'), null)
                }
            })
            if (is_checked) {
                this.address_importer_id = null
            }
        },

        fetchOrders (provider_type) {
            this.$utils.empty(this.data_orders_selected)
            this.$store
                .dispatch('shipping/fetch_orders', {
                    provider_type: provider_type,
                    order_type: this.order_type,
                    order_query: this.order_query,
                })
                .then((response) => {
                    this.data_orders = response.data
                })
                .catch((error) => {
                })
        },
        inputAddressToFromOrder () {
            this.$utils.set(this.value, {
                to_representative: this.data_orders_selected.address.Name,
                to_company: '',
                to_tel: this.data_orders_selected.address.Phone,
                to_email: '',
                to_tax_id: '',
                to_vat_id: '',
                to_eori: '',
                to_line1: this.data_orders_selected.address.Street1,
                to_line2: this.data_orders_selected.address.Street2,
                to_zip: this.data_orders_selected.address.PostalCode,
                to_city: this.data_orders_selected.address.CityName,
                to_state: this.data_orders_selected.address.StateOrProvince,
                to_country: this.data_orders_selected.address.CountryName,

                _no_importer: true,
            })
        },
        onRowClickedOrders (order) {
            this.$utils.set(this.data_orders_selected, order)
            this.$utils.empty(this.data_orders)
        },
        rateShippingCost () {
            this.$utils.empty(this.data_shipping)

            this.$store
                .dispatch('shipping/rate', this.value)
                .then((response) => {
                    this.data_shipping = response.data
                })
                .catch((error) => {
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

